import { render, staticRenderFns } from "./photographPhototheme.vue?vue&type=template&id=5a547e29&scoped=true&"
import script from "./photographPhototheme.vue?vue&type=script&lang=js&"
export * from "./photographPhototheme.vue?vue&type=script&lang=js&"
import style0 from "./photographPhototheme.vue?vue&type=style&index=0&id=5a547e29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a547e29",
  null
  
)

export default component.exports